import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { kinetik_api_url } from '../utilities/const';
import { connect } from 'react-redux';
import Checkbox from 'rc-checkbox';
import 'rc-checkbox/assets/index.css';

class BillingCreditCardModal extends Component {
    constructor(props){
        super(props);
        this.state = {
            agree_check: false,
            card_remember_check: false,
        };

    }

    createNewUser = () => {
        let first_name =  document.getElementById('first_name').value;
        let last_name =  document.getElementById('last_name').value;
        let user_email =  document.getElementById('user_email').value;
        let user_phone =  document.getElementById('user_phone').value;
        let address_data =  document.getElementById('address_data').value;
        let city_id =  document.getElementById('city_id').value;
        let state_id =  document.getElementById('state_id').value;
        let zip_id =  document.getElementById('zip_id').value;
        let card_number = document.getElementById('Credit_c_data').value;
        let dd_mm = document.getElementById('dd_mm').value;
        let ccv_data = document.getElementById('ccv_data').value;

        if (first_name !== '' && user_email !== '' && last_name !== '' && this.state.agree_check &&
           user_phone !== "" && address_data !== "" && city_id !== "" && state_id !== "" && zip_id !== ""
           && card_number !== "" && dd_mm !== "" && ccv_data !== "") {
            let URL = kinetik_api_url + '/saveBilling';

            let queryParam = {
                first_name,
                last_name,
                email: user_email,
                phone: user_phone,
                card_number,
                zip: zip_id,
                state: state_id,
                city: city_id,
                address: address_data,
                token: localStorage.getItem('authToken'),
                expiry_date: dd_mm,
                ccv_code: ccv_data
            };
            if(this.props.billingData.customer_id) {
                URL = kinetik_api_url + '/updateBilling';
                queryParam = {
                    first_name,
                    last_name,
                    email: user_email,
                    phone: user_phone,
                    card_number,
                    zip: zip_id,
                    state: state_id,
                    city: city_id,
                    address: address_data,
                    customer_id: this.props.billingData.customer_id,
                    token: localStorage.getItem('authToken'),
                    expiry_date: dd_mm,
                    ccv_code: ccv_data
                };

                axios.put(URL, queryParam)
                    .then((result) => {
                        window.alert(result.data.message);
                        this.props.hideOrShowEditingModal();
                    })
                    .catch((err) => {
                        window.alert(`${err.response.data.error.message}`);
                        console.log(err);
                    })
            }else {
                axios.post(URL, queryParam)
                .then((result) => {
                    window.alert(result.data.message);
                    this.props.hideOrShowEditingModal();
                })
                .catch((err) => {
                    window.alert(`${err.response.data.error.message}`);
                    console.log(err);
                })
            }
        } else {
            window.alert("Please fill out required fields to create new User");
        }
    }

    handleCardRemeberChange = (e) => {
        this.setState({
            [e.target.name]: e.target.checked
        });
    }
    render(){
        let {
          first_name,
          last_name,
          phone,
          email,
          address,
          city,
          state,
          zip,

        } = this.props.billingData;
        return(
            <div>
                <Modal show={this.props.show} onHide={this.props.hideOrShowEditingModal} className="userEdit_m">
                    <Modal.Header className="boarding_header_wrapper user_editing_h">
                        <Modal.Title>
                            <div className="boarding_modal_header user_editing_t">
                                <h3>Credit Card</h3>
                                <span>Add or edit your credit card</span>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-row inlined_item_c_card_wrapper">
                                    <div className="col-md-6">
                                        <div className="credit_c_fm_item">
                                            <input defaultValue={first_name} id="first_name" type="text" placeholder="First Name" />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="credit_c_fm_item">
                                            <input defaultValue={last_name} id="last_name" type="text" placeholder="Last Name" />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row inlined_item_c_card_wrapper">
                                    <div className="col-md-7">
                                        <div className="credit_c_fm_item">
                                            <input defaultValue={email} id="user_email" className="form-control" type="text" placeholder="Email" />
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="credit_c_fm_item">
                                            <input defaultValue={phone} id="user_phone" className="form-control" type="text" placeholder="Phone" />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row inlined_item_c_card_wrapper">
                                    <div className="col-md-12">
                                        <div className="credit_c_fm_item">
                                            <input defaultValue={address} id="address_data" className="form-control" type="text" placeholder="Address" />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row inlined_item_c_card_wrapper">
                                    <div className="col-md-6 mb-3">
                                        <div className="credit_c_fm_item">
                                            <input defaultValue={city} id="city_id" className="form-control" type="text" placeholder="City" />
                                        </div>
                                    </div>
                                        <div className="col-md-3 mb-3">
                                            <div className="credit_c_fm_item">
                                            <input defaultValue={state} id="state_id" className="form-control" type="text" placeholder="State" />
                                            </div>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <div className="credit_c_fm_item">
                                            <input defaultValue={zip} id="zip_id" className="form-control" type="text" placeholder="Zip" />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row inlined_item_c_card_wrapper">
                                    <div className="col-md-12">
                                        <div className="credit_c_fm_item input-group">
                                            <span className="input-group-addon" id="basic-addon1"><i className="fa fa-credit-card"></i></span>
                                            <input id="Credit_c_data" className="form-control" type="text" placeholder="3030- 4444- 2929 - 1112" />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row inlined_item_c_card_wrapper">
                                    <div className="col-md-4">
                                        <div className="credit_c_fm_item">
                                            <input id="dd_mm" className="form-control" type="text" placeholder="MM/YY" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="credit_c_fm_item">
                                            <input id="ccv_data" className="form-control" type="text" placeholder="CCV" />
                                        </div>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <div className="credit_c_fm_item fx_remember_c_card">
                                            <p>
                                                <label>
                                                    <Checkbox
                                                        name="card_remember_check"
                                                        onChange={this.handleCardRemeberChange}
                                                    />
                                                    &nbsp; remember my card
                                                </label>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row inlined_item_c_card_wrapper justify-content-md-center">
                                    <div className="col-md-3"></div>
                                    <div className="col-md-9">
                                        <div className="credit_c_fm_item fx_remember_c_card_agree">
                                            <p>
                                                <label>
                                                    <Checkbox
                                                        name="agree_check"
                                                        onChange={this.handleCardRemeberChange}
                                                    />
                                                    &nbsp; I agree on terms and services
                                                </label>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="create_user_m_btn_ on_c_card_modal">
                                    <input onClick={this.createNewUser} type="submit" className="settings_update_btn_signup" id="submit_box_signuop" value="Save/Update Card" />
                                </div><br />
                                <div className="cancel_btn_user_create">
                                    <h5 onClick={this.props.hideOrShowEditingModal}>Cancel</h5>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    billingData: state.billingData
})

export default connect(mapStateToProps, { })(BillingCreditCardModal);


// WEBPACK FOOTER //
// ./src/app/profile_settings/billingCreditCardModal.js